import { render, staticRenderFns } from "./Microsoft.vue?vue&type=template&id=3b6d355b&scoped=true"
import script from "./Microsoft.vue?vue&type=script&lang=js"
export * from "./Microsoft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6d355b",
  null
  
)

export default component.exports